import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";
import { colorTokens } from "theme/theme";

import { MODAL_FOOTER_HEIGHT } from "./components/Footer/constants/modalFooterHeight";
import { MODAL_HEADER_HEIGHT } from "./components/Header/constants/modalHeaderHeight";

export const rootStyles = css`
  display: grid;
  height: 100vh;
  left: 0;
  place-content: center;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1010; /* header の 1000 を超える値 */
`;

const ZIndexOfModal = {
  MODAL_MAIN: 20,
  OVER_LAYER: 10,
} as const;

export const overlayStyle = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${ZIndexOfModal.OVER_LAYER};

  background: #0000007a;
`;

export const modalStyle = css`
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 6px -2px #0000000d;
  display: grid;
  grid-template-rows: ${MODAL_HEADER_HEIGHT}px 1fr ${MODAL_FOOTER_HEIGHT}px;
  margin: auto;
  max-height: 100vh;
  max-width: 800px;
  position: relative;
  width: 100vw;
  z-index: ${ZIndexOfModal.MODAL_MAIN};
`;

export const bodyStyle = css`
  display: grid;
  flex-grow: 1;
  grid-template-columns: 100%;
  overflow-y: auto;

  ${MEDIA_QUERY_FOR_PC} {
    padding: 8px 24px;
    row-gap: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding: 6px 18px;
    row-gap: 18px;
  }

  /* スクロールバーを非表示にする */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

// base.cssが優先されてしまうため&[type="text"]を指定する
export const inputStyle = css`
  &[type="text"] {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid ${colorTokens.colors["border.tertiary"].default};
    color: ${colorTokens.colors["text.primary"].default};
    font-weight: 500;
    font-size: 18px;
    line-height: 1.5;
    padding: 10px 16px;
    width: 100%;
  }
  &[type="text"]::placeholder {
    color: #a3a3a3;
  }
`;

// 検索条件が少ない初期リリース時点で、 datepicker 分の高さを確保するためだけの要素・スタイル
// TODO: 検索条件が増えて datepicker を表示しても隠れなくなったら消す
export const wrapperForDatePicker = css`
  ${MEDIA_QUERY_FOR_PC} {
    min-height: 416px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    min-height: 322px;
  }
`;

export const dateRangeContainerStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const hyphenStyle = css`
  color: #a3a3a3;
  font-size: 16px;
  font-weight: 500;
`;

export const checkboxesWrapperStyle = css`
  display: grid;
  row-gap: 28px;
  ${MEDIA_QUERY_FOR_PC} {
    grid-template-columns: repeat(4, 25%);
  }

  ${MEDIA_QUERY_FOR_SP} {
    grid-template-columns: 100%;
  }
`;

export const checkboxLabelTextStyle = css`
  font-size: 16px;
`;
